export type ProductOrigin = { url: string; scrollY: number; time: number; kind: 'collection' | 'search' }
export const originKey = 'resa:product-origin:'
export const returnKey = 'resa:product-return'
const maxAge = 2 * 60 * 60 * 1000

export function listingKind(url: URL, root: string): ProductOrigin['kind'] | undefined {
	const path = url.pathname.slice(root.length)
	if (!url.pathname.startsWith(root)) return
	if (/^collections\/[^/]+\/?$/.test(path)) return 'collection'
	if (/^search\/?$/.test(path)) return 'search'
}

export function productPath(url: URL, root: string): string | undefined {
	if (!url.pathname.startsWith(root)) return
	const match = url.pathname.slice(root.length).match(/^(?:collections\/[^/]+\/)?products\/([^/]+)\/?$/)
	return match ? `${root}products/${match[1]}` : undefined
}

export function readOrigin(storage: Pick<Storage, 'getItem'> | undefined, key: string, base: URL, root: string, now = Date.now()): ProductOrigin | undefined {
	try {
		const value = JSON.parse(storage?.getItem(key) || 'null')
		if (!value || typeof value.url !== 'string') return
		const url = new URL(value.url, base)
		const kind = listingKind(url, root)
		if (url.origin !== base.origin || !kind || kind !== value.kind || url.username || url.password) return
		if (!Number.isFinite(value.scrollY) || value.scrollY < 0 || !Number.isFinite(value.time) || now - value.time > maxAge || value.time > now) return
		return { url: url.href, scrollY: value.scrollY, time: value.time, kind }
	} catch { return }
}

export function writeOrigin(storage: Pick<Storage, 'setItem'> | undefined, key: string, value: ProductOrigin): void {
	try { storage?.setItem(key, JSON.stringify(value)) } catch { /* Storage is optional. */ }
}

export function originLabel(origin: ProductOrigin | undefined, labels: { collection: string; search: string }): string {
	return labels[origin?.kind || 'collection']
}

export function canResumeOrigin(current: URL, referrer: string, root: string, navigationType?: string): boolean {
	if (navigationType === 'reload' || navigationType === 'back_forward') return true
	try {
		const previous = new URL(referrer)
		return previous.origin === current.origin && Boolean(listingKind(previous, root) || productPath(previous, root))
	} catch { return false }
}
